import * as React from 'react';

import {SectionHeader} from './section-header';

import styles from './billing-summary.module.css';

type Props = {
    title: string;
    linkProps:
        | {
              to: string;
              text: string;
          }
        | null
        | undefined;
};

export function TableSectionHeader(props: Props) {
    return (
        <thead>
            <tr>
                {/* @ts-expect-error */}
                <td colSpan='4' className={styles['section-header']}>
                    <SectionHeader title={props.title} linkProps={props.linkProps} />
                </td>
            </tr>
        </thead>
    );
}
